//create pageloader component which will be used if loading state is true in the app. please use animation or spinner to show loading state.

import React from 'react';
import './pageloader.css';

const PageLoader = () => {
    return (
        <div className="page-loader">
            <div className="loader"></div>
        </div>
    )
}

export default PageLoader;


 
 



